import { useState, CSSProperties } from "react";
import { Link } from 'react-router-dom';
import { DateTimeDisplay, Breadcrumbs } from "../../components/ui";
import Modal from "../../components/ui/Modal";
import SignupForm from "../../authentication/Signup";
import { useBreadcrumbs } from '../../hooks/useBreadcrumbs';

const RequestAccess = () => {
    // Default to showing the help/text content. The signup form will open in a modal.

    const breadcrumbs = useBreadcrumbs({
        currentPageTitle: 'Request Access',
    });

    const [isSignupModalOpen, setIsSignupModalOpen] = useState<boolean>(false);
    const [submissionSuccess, setSubmissionSuccess] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isClosing, setIsClosing] = useState(false);
    
    return (

        <main>
            <div className="container mb-2">
                <section className='page'>
                    <h2 className="heading__title heading__title--access">Request Access</h2>
                    <DateTimeDisplay />
                </section>
                <Breadcrumbs items={breadcrumbs} />
            

            
            <div className="alarm-content">
                {!submissionSuccess ? (
                    <>
                        <h3 className="heading__title heading__title--access mb-1">Request Access</h3>
                       
                        <p>
                            If you want to access the system, please <Link to="#" className="alarm-name-link" onClick={(e) => { e.preventDefault(); setIsSignupModalOpen(true); }}>click here to request access</Link>.
                        </p>
                        <p>
                            Alternatively, you can describe your reason for access and contact the administrator.
                        </p>
                    </>
                ) : (
                    <>
                        <h2 className='mt-1'>Thank You!</h2>
                        <p>Thank you, your details have been submitted and we will review shortly. Once you have been added to the system please use the login to the left to gain access to the system.</p>
                        <p>We will normally respond to your request within a 2hr period but please allow at least 24hrs before responding back.</p>
                    </>
                )}
            </div>
           </div>
  
        {/* Signup modal triggered from help text */}
        <Modal
            isOpen={isSignupModalOpen}
            title="Request Access"
            onCancel={() => {
                    setIsSignupModalOpen(false);
                    setIsSubmitting(false);
                }
            }
            onConfirm={() => {
                // Try to submit the form inside the modal (SignupForm contains a <form>)
                const form = document.querySelector('.modal__body form') as HTMLFormElement | null;
                if (form && typeof form.requestSubmit === 'function') {
                    setIsSubmitting(true);
                    form.requestSubmit();
                } else {
                    setIsSignupModalOpen(false);
                    setIsSubmitting(false);
                    setIsClosing(true);
                }
            }}
            okButtonLoading={isSubmitting}
            cancelButtonLoading={isClosing}
            content={<SignupForm isInsideModal={true} onSuccess={() => {
                setSubmissionSuccess(true);
                setIsSignupModalOpen(false);
                window.dispatchEvent(new CustomEvent('accessRequestSubmitted'));
            }} 
            onValidationError={() => {
                setIsSubmitting(false);
            }} />}
        />
         </main>
    );
};

export default RequestAccess;
